import { SettingsListItem } from '@/shared/ui/SettingsListItem'
import { useTranslation } from 'react-i18next'
import { Logout } from '@/shared/ui/Icons'
import {
    useAppStore,
    useEPGStore,
    useTVStore,
    useVisibilityStore,
    useVODStore,
} from '@/shared/store'
import { removeFromLocalStorage } from '@/shared/localStorage/localStorageRepository'
import { useEPGCache } from '@/shared/cache/hooks/useEPGCache'

interface Props {
    onClose: () => void
}

const LogoutButton: React.FC<Props> = ({ onClose }: Props) => {
    const { t: translate } = useTranslation()
    const { setLoginContentVisible } = useVisibilityStore()
    const { setIsUserLoggedIn, clearAppStorage } = useAppStore()
    const { clearEpgStore } = useEPGStore()
    const { clearTvStore } = useTVStore()
    const { setClearVod } = useVODStore()
    const { clearCache } = useEPGCache()

    const { isGuest } = useAppStore()
    const handleClick = () => {
        removeFromLocalStorage('dottv: sessionToken')
        removeFromLocalStorage('dottv: refreshToken')
        removeFromLocalStorage('dottv: lastTimeStart')
        removeFromLocalStorage('dottv:config')
        onClose()
        setLoginContentVisible()
        setIsUserLoggedIn(false)
        clearCache()
        clearEpgStore()
        clearTvStore()
        setClearVod()
        clearAppStorage()
    }

    return (
        <SettingsListItem
            key={isGuest ? translate('loginButtonText') : translate('logout')}
            icon={<Logout />}
            name={isGuest ? translate('loginButtonText') : translate('logout')}
            onClose={handleClick}
            link={'/'}
        />
    )
}

export { LogoutButton }
